import { render, staticRenderFns } from "./text-toolbar.vue?vue&type=template&id=c2ccd37e&scoped=true&"
import script from "./text-toolbar.vue?vue&type=script&lang=ts&"
export * from "./text-toolbar.vue?vue&type=script&lang=ts&"
import style0 from "./text-toolbar.vue?vue&type=style&index=0&id=c2ccd37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ccd37e",
  null
  
)

export default component.exports